export default __webpack_public_path__ + "static/SR USA - Caramel Color Product Guide-8ba6419856c82f5baa4b3516b5264d72.pdf";